import type { OrderStatusStep } from "../../core/types/order-detail";
import type { Props } from "../../core/types/tsx/components/order-detail/StatusTimeline.types";

const stateStyles: Record<OrderStatusStep["state"], string> = {
	done: "bg-primary border-primary text-white",
	current: "bg-white border-primary text-primary",
	pending: "bg-gray-100 border-gray-200 text-gray-400",
};

export function StatusTimeline({ steps }: Props) {
	return (
		<div className='rounded-2xl bg-white p-6 soft-border'>
			<p className='text-sm font-semibold text-gray-700 mb-4'>Estado del Pedido</p>
			<div className='flex flex-wrap gap-4'>
				{steps.map((step) => {
					const isCurrent = step.state === "current";
					const isDone = step.state === "done";
					return (
						<div key={step.label} className='flex items-center gap-3'>
							<span
								className={`flex h-10 w-10 items-center justify-center rounded-full border ${stateStyles[step.state]}`}
								aria-label={step.label}
							>
								{isDone ? (
									<svg
										xmlns='http://www.w3.org/2000/svg'
										className='h-5 w-5'
										fill='none'
										viewBox='0 0 24 24'
										stroke='currentColor'
									>
										<path
											strokeLinecap='round'
											strokeLinejoin='round'
											strokeWidth={2}
											d='M5 13l4 4L19 7'
										/>
									</svg>
								) : (
									<span
										className={`h-2 w-2 rounded-full ${isCurrent ? "bg-primary" : "bg-gray-300"}`}
										aria-hidden
									/>
								)}
							</span>
							<div>
								<p
									className={`text-sm font-medium ${isCurrent ? "text-primary" : "text-gray-600"}`}
								>
									{step.label}
								</p>
								<p className='text-xs text-gray-400'>{step.date}</p>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default StatusTimeline;
